import { render, staticRenderFns } from "./ExNewBadge.vue?vue&type=template&id=f44d2e7c&scoped=true"
import script from "./ExNewBadge.vue?vue&type=script&lang=js"
export * from "./ExNewBadge.vue?vue&type=script&lang=js"
import style0 from "./ExNewBadge.vue?vue&type=style&index=0&id=f44d2e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d2e7c",
  null
  
)

export default component.exports